module.exports = __webpack_public_path__ + "media/assets/img/comunicate-cac5284c5749a959a99d9199a072f5bb.svg";